import { useEffect } from 'react';
import { Providers } from './providers';
import { AppRoutes } from './routes';
import { Shell } from '@/components/layout';
import { initializeTheme } from '@/stores';

/**
 * Root application component.
 *
 * Sets up providers, initializes theme, and renders the main layout.
 */
export function App() {
  useEffect(() => {
    initializeTheme();
  }, []);

  return (
    <Providers>
      <Shell>
        <AppRoutes />
      </Shell>
    </Providers>
  );
}
